import React, { useState, useEffect, useRef } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { Footer } from '../components/Footer';
import { careerApiRepository } from '../../infrastructure/careerApiRepository';
import { termsRepository } from '../../infrastructure/termsApiRepository';
import { useAuthContext } from '../../../../features/auth/application/AuthContext';
import '../styles/landing.css';

const EMPLOYMENT_TYPE_LABEL = { FULL_TIME: '정규직', CONTRACT: '계약직', INTERN: '인턴' };

const EXPERIENCE_OPTIONS = [
    { value: '신입', label: '신입' },
    { value: '1년미만', label: '1년 미만' },
    { value: '1~3년', label: '1 ~ 3년' },
    { value: '3~5년', label: '3 ~ 5년' },
    { value: '5~10년', label: '5 ~ 10년' },
    { value: '10년이상', label: '10년 이상' },
];

const CAREER_EMPLOYMENT_OPTIONS = [
    { value: '정규직', label: '정규직' },
    { value: '계약직', label: '계약직' },
    { value: '인턴', label: '인턴' },
    { value: '프리랜서', label: '프리랜서' },
    { value: '기타', label: '기타' },
];

const EMAIL_DOMAINS = [
    { value: 'naver.com', label: 'naver.com' },
    { value: 'gmail.com', label: 'gmail.com' },
    { value: 'daum.net', label: 'daum.net' },
    { value: 'kakao.com', label: 'kakao.com' },
    { value: 'hanmail.net', label: 'hanmail.net' },
    { value: 'nate.com', label: 'nate.com' },
    { value: 'custom', label: '직접입력' },
];

const EMPTY_CAREER = { companyName: '', startDate: '', endDate: '', isCurrent: false, employmentType: '', jobRole: '', position: '', mainDuties: '' };

function calcDday(deadlineAt) {
    if (!deadlineAt) return null;
    const now = new Date(); now.setHours(0,0,0,0);
    const dl  = new Date(deadlineAt); dl.setHours(0,0,0,0);
    return Math.ceil((dl - now) / 86400000);
}
function fmtMD(d) {
    if (!d) return '';
    const dt = new Date(d);
    return `${String(dt.getMonth()+1).padStart(2,'0')}월${String(dt.getDate()).padStart(2,'0')}일`;
}
function fmtFull(d) {
    if (!d) return '';
    const dt = new Date(d);
    return `${dt.getFullYear()}.${String(dt.getMonth()+1).padStart(2,'0')}.${String(dt.getDate()).padStart(2,'0')}`;
}
function parseContent(raw) {
    if (!raw) return null;
    try {
        const p = typeof raw === 'object' ? raw : JSON.parse(raw);
        if (p && typeof p === 'object' && !Array.isArray(p)) return p;
    } catch {}
    return null;
}
function fmtPhone(v) {
    const d = v.replace(/\D/g,'');
    if (d.startsWith('02')) {
        if (d.length <= 2) return d;
        if (d.length <= 5) return `${d.slice(0,2)}-${d.slice(2)}`;
        if (d.length <= 9) return `${d.slice(0,2)}-${d.slice(2,5)}-${d.slice(5)}`;
        return `${d.slice(0,2)}-${d.slice(2,6)}-${d.slice(6,10)}`;
    }
    const s = d.slice(0,11);
    if (s.length <= 3) return s;
    if (s.length <= 7) return `${s.slice(0,3)}-${s.slice(3)}`;
    if (s.length <= 10) return `${s.slice(0,3)}-${s.slice(3,6)}-${s.slice(6)}`;
    return `${s.slice(0,3)}-${s.slice(3,7)}-${s.slice(7)}`;
}

/* ── 공용 UI 컴포넌트 ── */
function SelectDropdown({ name, value, onChange, options, placeholder = '선택하세요' }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const selected = options.find(o => o.value === value);
    useEffect(() => {
        const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', h);
        return () => document.removeEventListener('mousedown', h);
    }, []);
    return (
        <div className="cdp-select" ref={ref}>
            <button type="button" className={`cdp-select-btn${value ? ' cdp-select-btn--val' : ''}${open ? ' cdp-select-btn--open' : ''}`}
                onClick={() => setOpen(v => !v)}>
                <span>{selected ? selected.label : placeholder}</span>
                <svg className={`cdp-select-arrow${open ? ' open' : ''}`} width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><polyline points="6 9 12 15 18 9"/></svg>
            </button>
            {open && (
                <ul className="cdp-select-list">
                    {options.map(o => (
                        <li key={o.value} className={`cdp-select-item${o.value === value ? ' cdp-select-item--sel' : ''}`}
                            onClick={() => { onChange({ target: { name, value: o.value } }); setOpen(false); }}>
                            {o.value === value && <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><polyline points="20 6 9 17 4 12"/></svg>}
                            {o.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

function BirthSelect({ value, onChange, options, placeholder }) {
    const [open, setOpen] = useState(false);
    const ref = useRef(null);
    const listRef = useRef(null);
    const selected = options.find(o => String(o.value) === String(value));
    useEffect(() => {
        const h = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
        document.addEventListener('mousedown', h);
        return () => document.removeEventListener('mousedown', h);
    }, []);
    useEffect(() => {
        if (open && listRef.current && value) {
            const el = listRef.current.querySelector('.cdp-birth-item--sel');
            if (el) el.scrollIntoView({ block: 'nearest' });
        }
    }, [open, value]);
    return (
        <div className="cdp-birth" ref={ref}>
            <button type="button" className={`cdp-birth-btn${open ? ' cdp-birth-btn--open' : ''}`} onClick={() => setOpen(v => !v)}>
                <span className={selected ? '' : 'cdp-birth-ph'}>{selected ? selected.label : placeholder}</span>
                <span className="cdp-birth-arrow">▼</span>
            </button>
            {open && (
                <ul className="cdp-birth-list" ref={listRef}>
                    {options.map(o => (
                        <li key={o.value} className={`cdp-birth-item${String(o.value) === String(value) ? ' cdp-birth-item--sel' : ''}`}
                            onClick={() => { onChange(String(o.value)); setOpen(false); }}>
                            {o.label}
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
}

/* ── 섹션 박스 (공고 내용) ── */
function ContentSection({ title, items, accent }) {
    if (!items || items.length === 0) return null;
    return (
        <div className="crd2-section-box">
            <h3 className="crd2-section-box-title" style={{ color: accent || '#1c1814' }}>{title}</h3>
            <ul className="crd2-section-list">
                {items.map((item, i) => <li key={i} className="crd2-section-item">{item}</li>)}
            </ul>
        </div>
    );
}

/* ── 지원 모달 ── */
function ApplyModal({ posting, accessToken, onClose, onSuccess }) {
    const fileInputRef = useRef(null);

    const [form, setForm] = useState({ name: '', phone: '', gender: '', address: '', addressDetail: '', jobExperienceLevel: '', privacyAgreed: false });
    const [emailLocal, setEmailLocal] = useState('');
    const [emailDomain, setEmailDomain] = useState('');
    const [emailDomainCustom, setEmailDomainCustom] = useState('');
    const [birthYear, setBirthYear] = useState('');
    const [birthMonth, setBirthMonth] = useState('');
    const [birthDay, setBirthDay] = useState('');
    const [careerList, setCareerList] = useState([]);
    const [resumeFile, setResumeFile] = useState(null);
    const [submitting, setSubmitting] = useState(false);
    const [error, setError] = useState('');
    const [privacyTerms, setPrivacyTerms] = useState(null);
    const [showTerms, setShowTerms] = useState(false);

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        termsRepository.getTermsByType('JOB_SEEKER_PRIVACY').then(setPrivacyTerms).catch(() => {});
        return () => { document.body.style.overflow = ''; };
    }, []);

    const email = (() => {
        const domain = emailDomain === 'custom' ? emailDomainCustom : emailDomain;
        return emailLocal && domain ? `${emailLocal}@${domain}` : '';
    })();

    const birthDate = birthYear && birthMonth && birthDay
        ? `${birthYear}-${String(birthMonth).padStart(2,'0')}-${String(birthDay).padStart(2,'0')}` : '';

    const handleChange = e => {
        const { name, value, type, checked } = e.target;
        if (name === 'phone') { setForm(p => ({ ...p, phone: fmtPhone(value) })); return; }
        setForm(p => ({ ...p, [name]: type === 'checkbox' ? checked : value }));
    };

    const handleEmailDomainSelect = e => {
        const d = e.target.value;
        setEmailDomain(d);
        if (d === 'custom') setEmailDomainCustom('');
    };

    const handleFileChange = e => {
        const file = e.target.files[0];
        if (!file) return;
        const allowed = ['application/pdf','application/msword','application/vnd.openxmlformats-officedocument.wordprocessingml.document'];
        if (!allowed.includes(file.type)) { setError('PDF, DOC, DOCX 파일만 업로드 가능합니다.'); return; }
        if (file.size > 10*1024*1024) { setError('파일 크기는 10MB 이하여야 합니다.'); return; }
        setResumeFile(file); setError('');
    };

    const addCareer = () => setCareerList(p => [...p, { ...EMPTY_CAREER }]);
    const updateCareer = (i, field, val) => setCareerList(p => p.map((c, idx) => {
        if (idx !== i) return c;
        const u = { ...c, [field]: val };
        if (field === 'isCurrent' && val) u.endDate = '';
        return u;
    }));
    const removeCareer = i => setCareerList(p => p.filter((_, idx) => idx !== i));

    const handleAddressSearch = () => {
        const open = () => new window.daum.Postcode({
            oncomplete: data => setForm(p => ({ ...p, address: data.roadAddress }))
        }).open();
        if (!window.daum?.Postcode) {
            const s = document.createElement('script');
            s.src = '//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
            s.onload = open; document.head.appendChild(s);
        } else open();
    };

    const validate = () => {
        if (!form.name.trim()) return '이름을 입력해 주세요.';
        if (!form.gender) return '성별을 선택해 주세요.';
        if (!form.phone.trim()) return '연락처를 입력해 주세요.';
        if (!/^(02-\d{3,4}-\d{4}|0\d{1,2}-\d{3,4}-\d{4}|1[0-9]{3}-\d{4})$/.test(form.phone)) return '연락처 형식이 올바르지 않습니다.';
        if (!birthDate) return '생년월일을 선택해 주세요.';
        if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return '이메일 형식이 올바르지 않습니다.';
        if (!form.address) return '주소를 검색해 주세요.';
        if (!form.jobExperienceLevel) return '경력을 선택해 주세요.';
        if (!form.privacyAgreed) return '개인정보 수집·이용에 동의해 주세요.';
        return null;
    };

    const handleSubmit = async e => {
        e.preventDefault();
        const err = validate();
        if (err) { setError(err); return; }
        setSubmitting(true); setError('');
        try {
            const fd = new FormData();
            fd.append('applicantName',  form.name.trim());
            fd.append('applicantPhone', form.phone.replace(/-/g,''));
            if (email) fd.append('applicantEmail', email);
            fd.append('gender', form.gender);
            fd.append('birthDate', birthDate);
            fd.append('address', form.address);
            if (form.addressDetail.trim()) fd.append('addressDetail', form.addressDetail.trim());
            fd.append('jobExperienceLevel', form.jobExperienceLevel);
            if (careerList.length > 0) fd.append('careerHistories', JSON.stringify(careerList));
            if (resumeFile) fd.append('resumeFile', resumeFile);
            await careerApiRepository.applyCareer(posting.id, fd, accessToken);
            onSuccess(form.name);
        } catch (err) {
            setError(err.message || '지원서 제출 중 오류가 발생했습니다.');
        } finally { setSubmitting(false); }
    };

    return (
        <div className="cdp-backdrop" onClick={onClose}>
            <div className="cdp-modal" onClick={e => e.stopPropagation()}>
                {/* 헤더 */}
                <div className="cdp-modal-hd">
                    <div>
                        {posting.department && <p className="cdp-modal-dept">{posting.department}</p>}
                        <h2 className="cdp-modal-title">{posting.title} 지원</h2>
                    </div>
                    <button className="cdp-modal-close" onClick={onClose} aria-label="닫기">✕</button>
                </div>

                {/* 본문 */}
                <div className="cdp-modal-body">
                    <form onSubmit={handleSubmit} noValidate>

                        {/* 기본 정보 */}
                        <p className="cdp-section-label">기본 정보</p>

                        <div className="cdp-row2">
                            <div className="cdp-field">
                                <label className="cdp-label">이름 <span className="cdp-req">*</span></label>
                                <input className="cdp-input" name="name" value={form.name} onChange={handleChange} placeholder="홍길동" maxLength={100} autoFocus />
                            </div>
                            <div className="cdp-field">
                                <label className="cdp-label">연락처 <span className="cdp-req">*</span></label>
                                <input className="cdp-input" name="phone" value={form.phone} onChange={handleChange} placeholder="010-0000-0000" inputMode="tel" />
                            </div>
                        </div>

                        <div className="cdp-row2">
                            <div className="cdp-field">
                                <label className="cdp-label">생년월일 <span className="cdp-req">*</span></label>
                                <div className="cdp-birth-row">
                                    <BirthSelect value={birthYear} placeholder="년도"
                                        onChange={v => { setBirthYear(v); setBirthDay(''); }}
                                        options={Array.from({ length: 66 }, (_, i) => 2010 - i).map(y => ({ value: y, label: `${y}년` }))} />
                                    <BirthSelect value={birthMonth} placeholder="월"
                                        onChange={v => { setBirthMonth(v); setBirthDay(''); }}
                                        options={Array.from({ length: 12 }, (_, i) => i+1).map(m => ({ value: m, label: `${m}월` }))} />
                                    <BirthSelect value={birthDay} placeholder="일"
                                        onChange={setBirthDay}
                                        options={Array.from({ length: birthYear && birthMonth ? new Date(Number(birthYear), Number(birthMonth), 0).getDate() : 31 }, (_, i) => i+1).map(d => ({ value: d, label: `${d}일` }))} />
                                </div>
                            </div>
                            <div className="cdp-field">
                                <label className="cdp-label">성별 <span className="cdp-req">*</span></label>
                                <div className="cdp-radio-group">
                                    {[{ value: 'M', label: '남성' }, { value: 'F', label: '여성' }].map(o => (
                                        <label key={o.value} className={`cdp-radio${form.gender === o.value ? ' cdp-radio--on' : ''}`}>
                                            <input type="radio" name="gender" value={o.value} checked={form.gender === o.value} onChange={handleChange} />
                                            {o.label}
                                        </label>
                                    ))}
                                </div>
                            </div>
                        </div>

                        <div className="cdp-field">
                            <label className="cdp-label">이메일 <span className="cdp-opt">(선택)</span></label>
                            <div className="cdp-email-row">
                                <input className="cdp-input cdp-email-local" value={emailLocal}
                                    onChange={e => setEmailLocal(e.target.value)} placeholder="이메일 아이디" inputMode="email" />
                                <span className="cdp-at">@</span>
                                <div className="cdp-email-domain">
                                    <SelectDropdown name="emailDomain" value={emailDomain}
                                        onChange={handleEmailDomainSelect} options={EMAIL_DOMAINS} placeholder="도메인 선택" />
                                </div>
                            </div>
                            {emailDomain === 'custom' && (
                                <input className="cdp-input" style={{ marginTop: 8 }} value={emailDomainCustom}
                                    onChange={e => setEmailDomainCustom(e.target.value)} placeholder="도메인 입력 (예: company.com)" />
                            )}
                            {email && <p className="cdp-email-preview">✉ {email}</p>}
                        </div>

                        {/* 주소 */}
                        <p className="cdp-section-label" style={{ marginTop: 20 }}>주소</p>

                        <div className="cdp-field">
                            <label className="cdp-label">주소 <span className="cdp-req">*</span></label>
                            <div className="cdp-addr-row">
                                <input className="cdp-input cdp-addr-input" value={form.address} readOnly placeholder="주소 검색을 클릭하세요" />
                                <button type="button" className="cdp-addr-btn" onClick={handleAddressSearch}>주소 검색</button>
                            </div>
                        </div>
                        <div className="cdp-field">
                            <label className="cdp-label">상세주소 <span className="cdp-opt">(선택)</span></label>
                            <input className="cdp-input" name="addressDetail" value={form.addressDetail} onChange={handleChange} placeholder="상세주소를 입력하세요" />
                        </div>

                        {/* 경력 */}
                        <p className="cdp-section-label" style={{ marginTop: 20 }}>경력</p>

                        <div className="cdp-field">
                            <label className="cdp-label">경력 <span className="cdp-req">*</span></label>
                            <SelectDropdown name="jobExperienceLevel" value={form.jobExperienceLevel}
                                onChange={handleChange} options={EXPERIENCE_OPTIONS} placeholder="경력을 선택하세요" />
                        </div>

                        <div className="cdp-career-header">
                            <span className="cdp-section-label" style={{ margin: 0 }}>경력사항</span>
                            <button type="button" className="cdp-career-add" onClick={addCareer}>
                                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
                                경력 추가
                            </button>
                        </div>

                        {careerList.length === 0 && (
                            <div className="cdp-career-empty">+ 경력 추가 버튼을 눌러 경력사항을 입력해주세요.</div>
                        )}

                        {careerList.map((c, i) => (
                            <div key={i} className="cdp-career-item">
                                <div className="cdp-career-item-hd">
                                    <span className="cdp-career-num">경력 {i+1}</span>
                                    <button type="button" className="cdp-career-del" onClick={() => removeCareer(i)}>삭제</button>
                                </div>
                                <div className="cdp-career-body">
                                    <div className="cdp-row2">
                                        <div className="cdp-field">
                                            <label className="cdp-label">회사명</label>
                                            <input className="cdp-input" placeholder="회사명" value={c.companyName} onChange={e => updateCareer(i,'companyName',e.target.value)} />
                                        </div>
                                        <div className="cdp-field">
                                            <label className="cdp-label">재직형태</label>
                                            <SelectDropdown name={`et-${i}`} value={c.employmentType}
                                                onChange={e => updateCareer(i,'employmentType',e.target.value)}
                                                options={CAREER_EMPLOYMENT_OPTIONS} placeholder="선택" />
                                        </div>
                                    </div>
                                    <div className="cdp-row2">
                                        <div className="cdp-field">
                                            <label className="cdp-label">직무</label>
                                            <input className="cdp-input" placeholder="직무" value={c.jobRole} onChange={e => updateCareer(i,'jobRole',e.target.value)} />
                                        </div>
                                        <div className="cdp-field">
                                            <label className="cdp-label">직책</label>
                                            <input className="cdp-input" placeholder="직책" value={c.position} onChange={e => updateCareer(i,'position',e.target.value)} />
                                        </div>
                                    </div>
                                    <div className="cdp-field">
                                        <label className="cdp-label">재직기간</label>
                                        <div className="cdp-period">
                                            <input className="cdp-input" type="date" value={c.startDate} onChange={e => updateCareer(i,'startDate',e.target.value)} />
                                            <span className="cdp-period-sep">~</span>
                                            <input className="cdp-input" type="date" value={c.endDate} disabled={c.isCurrent} onChange={e => updateCareer(i,'endDate',e.target.value)} />
                                            <label className="cdp-current-check">
                                                <input type="checkbox" checked={c.isCurrent} onChange={e => updateCareer(i,'isCurrent',e.target.checked)} />
                                                현재 재직 중
                                            </label>
                                        </div>
                                    </div>
                                    <div className="cdp-field">
                                        <label className="cdp-label">주요 업무내용</label>
                                        <textarea className="cdp-textarea" rows={3} maxLength={1000} placeholder="담당 업무를 입력해주세요."
                                            value={c.mainDuties} onChange={e => updateCareer(i,'mainDuties',e.target.value)} />
                                        <span className="cdp-char-count">{c.mainDuties.length} / 1000</span>
                                    </div>
                                </div>
                            </div>
                        ))}

                        {/* 이력서 */}
                        <p className="cdp-section-label" style={{ marginTop: 20 }}>이력서 <span className="cdp-opt">(선택)</span></p>

                        <div className="cdp-upload" onClick={() => fileInputRef.current?.click()}>
                            {resumeFile ? (
                                <span className="cdp-upload-name">📎 {resumeFile.name}</span>
                            ) : (
                                <>
                                    <span className="cdp-upload-icon">⬆</span>
                                    <span>파일을 선택하세요</span>
                                    <span className="cdp-upload-hint">PDF, DOC, DOCX (최대 10MB)</span>
                                </>
                            )}
                        </div>
                        <input ref={fileInputRef} type="file" accept=".pdf,.doc,.docx" style={{ display:'none' }} onChange={handleFileChange} />

                        {/* 개인정보 동의 */}
                        <label className="cdp-privacy">
                            <input type="checkbox" name="privacyAgreed" checked={form.privacyAgreed} onChange={handleChange} />
                            <span>
                                개인정보 수집·이용에 동의합니다.{' '}
                                <button type="button" className="cdp-terms-link" onClick={() => setShowTerms(true)}>내용보기</button>
                            </span>
                        </label>

                        {error && <p className="cdp-error">{error}</p>}

                        {/* 버튼 */}
                        <div className="cdp-modal-ft">
                            <button type="button" className="cdp-btn-cancel" onClick={onClose}>취소</button>
                            <button type="submit" className="cdp-btn-submit" disabled={submitting}>
                                {submitting ? '제출 중...' : '지원서 제출'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* 개인정보처리방침 모달 */}
            {showTerms && (
                <div className="cdp-terms-backdrop" onClick={() => setShowTerms(false)}>
                    <div className="cdp-terms-modal" onClick={e => e.stopPropagation()}>
                        <div className="cdp-terms-hd">
                            <h3>{privacyTerms?.title || '개인정보처리방침'}</h3>
                            <button className="cdp-modal-close" onClick={() => setShowTerms(false)}>✕</button>
                        </div>
                        <div className="cdp-terms-body">
                            {privacyTerms?.content
                                ? privacyTerms.content.split('\n').map((line, i) => <p key={i}>{line || <br />}</p>)
                                : <p>불러오는 중...</p>}
                        </div>
                        <div className="cdp-terms-ft">
                            <button className="cdp-btn-submit" onClick={() => { setForm(p => ({ ...p, privacyAgreed: true })); setShowTerms(false); }}>
                                동의하고 닫기
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

/* ── 메인 페이지 ── */
export function CareerDetailPage() {
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const { isLoggedIn, accessToken } = useAuthContext();

    const [posting,   setPosting]   = useState(null);
    const [loading,   setLoading]   = useState(true);
    const [notFound,  setNotFound]  = useState(false);
    const [modalOpen, setModalOpen] = useState(false);
    const [success,   setSuccess]   = useState(null);

    useEffect(() => {
        careerApiRepository.getCareerById(id)
            .then(setPosting)
            .catch(() => setNotFound(true))
            .finally(() => setLoading(false));
    }, [id]);

    const handleApplyClick = () => {
        if (!isLoggedIn) { navigate('/login', { state: { from: location.pathname } }); return; }
        setModalOpen(true);
    };

    const handleSuccess = name => {
        setModalOpen(false);
        setSuccess(name);
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const dday = posting ? calcDday(posting.deadlineAt) : null;
    const ddayLabel = dday === null ? '상시' : dday === 0 ? 'D-Day' : dday < 0 ? '마감' : `D-${dday}`;
    const ddayUrgent = dday !== null && dday >= 0 && dday <= 7;
    const isClosed = dday !== null && dday < 0;
    const content = posting ? parseContent(posting.content) : null;

    return (
        <>
            <div style={{ minHeight: '100vh', background: '#fff' }}>
                {loading ? (
                    <div className="crd2-state"><div className="crd2-spinner" /><p style={{ color:'#888', margin:0 }}>불러오는 중...</p></div>
                ) : notFound ? (
                    <div className="crd2-state">
                        <p className="crd2-state-title">채용 공고를 찾을 수 없습니다</p>
                        <p className="crd2-state-sub">마감되었거나 존재하지 않는 공고입니다.</p>
                        <button className="crd2-btn-primary" onClick={() => navigate('/careers')}>채용 목록으로</button>
                    </div>
                ) : success ? (
                    <div className="crd2-state">
                        <div className="crd2-success-icon">
                            <svg viewBox="0 0 52 52" width="56" height="56">
                                <circle cx="26" cy="26" r="25" fill="none" stroke="#f16102" strokeWidth="2" className="crd2-circle"/>
                                <path fill="none" stroke="#f16102" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" d="M14 27l8 8 16-16" className="crd2-check"/>
                            </svg>
                        </div>
                        <p className="crd2-state-title">지원서가 접수되었습니다</p>
                        <p style={{ color:'#555', margin:'0 0 4px' }}>{success}님의 지원서를 잘 받았습니다.</p>
                        <p className="crd2-state-sub">검토 후 빠른 시일 내에 연락드리겠습니다.</p>
                        <button className="crd2-btn-primary" style={{ marginTop:28 }} onClick={() => navigate('/careers')}>채용 목록으로</button>
                    </div>
                ) : (
                    <div className="crd2-wrap">
                        <button className="crd2-back" onClick={() => navigate('/careers')}>← 채용 목록</button>

                        <div className="crd2-title-area">
                            {posting.department && <p className="crd2-dept">{posting.department}</p>}
                            <h1 className="crd2-title">{posting.title}</h1>
                        </div>

                        <div className="crd2-dday-banner">
                            <div className="crd2-dday-left">
                                {dday !== null && dday >= 0 ? (<>공고마감&nbsp;<span className={`crd2-dday-label${ddayUrgent?' crd2-dday--urgent':''}`}>{ddayLabel}</span>&nbsp;확인해주세요!</>)
                                : dday === null ? (<><span className="crd2-dday-label crd2-dday--always">상시채용</span>&nbsp;진행 중입니다.</>)
                                : (<span style={{ color:'#aaa' }}>해당 공고는 마감되었습니다.</span>)}
                            </div>
                            <div className="crd2-dday-right">
                                <span className="crd2-date-item"><span className="crd2-date-label">게시</span><span className="crd2-date-val">{fmtMD(posting.createdAt)}</span></span>
                                <span className="crd2-date-sep">|</span>
                                <span className="crd2-date-item"><span className="crd2-date-label">마감</span><span className="crd2-date-val">{posting.deadlineAt ? fmtMD(posting.deadlineAt) : '상시'}</span></span>
                            </div>
                        </div>

                        <div className="crd2-info-card">
                            <div className="crd2-info-header">
                                <span className="crd2-company-name">RISING BROKERS</span>
                                <span className="crd2-info-url">risingbrokers.co.kr</span>
                            </div>
                            <p className="crd2-info-desc">
                                라이징브로커즈는 보험 설계사·매니저 전문 채용 플랫폼을 운영하는 HR Tech 스타트업입니다.<br />
                                보험 업계의 디지털 혁신을 이끌 인재와 함께 성장하고 싶습니다.
                            </p>
                            <div className="crd2-info-footer">
                                <div className="crd2-info-meta">
                                    <span className="crd2-info-type">{EMPLOYMENT_TYPE_LABEL[posting.employmentType] || posting.employmentType}</span>
                                    {posting.deadlineAt && <span className="crd2-info-deadline">마감 {fmtFull(posting.deadlineAt)}</span>}
                                </div>
                            </div>
                        </div>

                        <h2 className="crd2-h2">모집직무 및 지원자격</h2>

                        {content ? (
                            <div className="crd2-content-area">
                                <div className="crd2-job-card">
                                    <div className="crd2-job-card-title">{posting.title}</div>
                                    <div className="crd2-job-card-divider" />
                                    <ContentSection title="수행업무"  items={content.duties}       accent="#1a56c4" />
                                    <ContentSection title="지원자격"  items={content.requirements} accent="#1a56c4" />
                                    <ContentSection title="우대사항"  items={content.preferences}  accent="#1a56c4" />
                                    <ContentSection title="복지사항"  items={content.benefits}     accent="#1a56c4" />
                                </div>
                            </div>
                        ) : (
                            <div className="crd2-plain-content">{posting.content}</div>
                        )}

                        <div style={{ height: 80 }} />
                    </div>
                )}
            </div>

            {posting && !loading && !notFound && !success && (
                <div className="crd2-fab-wrap">
                    <button className={`crd2-fab-btn${isClosed?' crd2-fab-btn--closed':''}`}
                        onClick={handleApplyClick} disabled={isClosed}>
                        {isClosed ? '마감된 공고입니다' : '지원하기'}
                    </button>
                </div>
            )}

            {modalOpen && posting && (
                <ApplyModal posting={posting} accessToken={accessToken}
                    onClose={() => setModalOpen(false)} onSuccess={handleSuccess} />
            )}

            <Footer />

            <style>{`
                /* ── 공고 상세 레이아웃 ── */
                .crd2-wrap { max-width:1100px; margin:0 auto; padding:36px 60px 40px; }
                .crd2-back { background:none; border:none; padding:0; font-size:0.85rem; color:#aaa; cursor:pointer; margin-bottom:28px; display:inline-block; transition:color .15s; }
                .crd2-back:hover { color:#333; }
                .crd2-title-area { margin-bottom:24px; }
                .crd2-dept  { font-size:0.825rem; color:#999; margin:0 0 8px; text-align:left; }
                .crd2-title { font-size:1.75rem; font-weight:800; color:#1c1814; margin:0; line-height:1.3; letter-spacing:-0.03em; text-align:left; }
                .crd2-dday-banner { display:flex; align-items:center; justify-content:space-between; border:1.5px solid #ddd; border-radius:6px; padding:18px 24px; margin-bottom:24px; flex-wrap:wrap; gap:12px; }
                .crd2-dday-left { font-size:0.95rem; font-weight:700; color:#1c1814; display:flex; align-items:center; gap:4px; flex-wrap:wrap; }
                .crd2-dday-label { color:#f16102; font-weight:800; }
                .crd2-dday--urgent { color:#e53e3e; }
                .crd2-dday--always { color:#3d9e6e; }
                .crd2-dday-right { display:flex; align-items:center; gap:12px; font-size:0.875rem; color:#555; }
                .crd2-date-item { display:flex; align-items:center; gap:6px; }
                .crd2-date-label { color:#aaa; font-size:0.8rem; }
                .crd2-date-val   { font-weight:600; color:#333; }
                .crd2-date-sep   { color:#ddd; }
                .crd2-info-card  { background:#f8f7f5; border-radius:8px; padding:20px 24px; margin-bottom:40px; }
                .crd2-info-header { display:flex; align-items:center; gap:14px; margin-bottom:10px; }
                .crd2-company-name { font-size:0.875rem; font-weight:800; color:#f16102; letter-spacing:0.05em; }
                .crd2-info-url  { font-size:0.8rem; color:#999; }
                .crd2-info-desc { font-size:0.875rem; color:#555; line-height:1.7; margin:0 0 14px; text-align:left; }
                .crd2-info-footer { display:flex; align-items:center; justify-content:space-between; }
                .crd2-info-meta   { display:flex; align-items:center; gap:12px; }
                .crd2-info-type   { font-size:0.8rem; font-weight:600; color:#777; background:#eee; padding:3px 10px; border-radius:4px; }
                .crd2-info-deadline { font-size:0.8rem; color:#999; }
                .crd2-h2 { font-size:1.3rem; font-weight:800; color:#1c1814; margin:0 0 20px; letter-spacing:-0.02em; text-align:left; }
                .crd2-content-area { margin-bottom:40px; }
                .crd2-job-card { border:1.5px solid #e0dbd5; border-radius:8px; padding:28px 32px; }
                .crd2-job-card-title { font-size:1rem; font-weight:700; color:#1c1814; margin-bottom:16px; text-align:left; }
                .crd2-job-card-divider { height:1px; background:#e8e3de; margin-bottom:20px; }
                .crd2-section-box { margin-bottom:20px; }
                .crd2-section-box:last-child { margin-bottom:0; }
                .crd2-section-box-title { font-size:0.875rem; font-weight:700; margin:0 0 10px; text-align:left; }
                .crd2-section-list { margin:0; padding:0; list-style:none; display:flex; flex-direction:column; gap:6px; }
                .crd2-section-item { font-size:0.875rem; color:#444; line-height:1.6; padding-left:14px; position:relative; text-align:left; }
                .crd2-section-item::before { content:'-'; position:absolute; left:0; color:#aaa; }
                .crd2-plain-content { border:1.5px solid #e0dbd5; border-radius:8px; padding:28px 32px; font-size:0.9rem; color:#444; line-height:1.8; white-space:pre-line; margin-bottom:40px; text-align:left; }

                /* ── 고정 버튼 ── */
                .crd2-fab-wrap { position:fixed; bottom:0; left:0; right:0; background:#fff; border-top:1px solid #ece7e2; padding:14px 24px; display:flex; justify-content:center; z-index:200; box-shadow:0 -4px 16px rgba(0,0,0,.06); }
                .crd2-fab-btn { width:100%; max-width:480px; padding:14px 0; background:#1c1814; color:#fff; border:none; border-radius:8px; font-size:1rem; font-weight:700; cursor:pointer; transition:background .15s; }
                .crd2-fab-btn:hover:not(:disabled) { background:#f16102; }
                .crd2-fab-btn--closed { background:#ccc; color:#888; cursor:not-allowed; }
                .crd2-fab-btn--closed:hover { background:#ccc; }

                /* ── 지원 모달 ── */
                .cdp-backdrop { position:fixed; inset:0; background:rgba(0,0,0,.48); display:flex; align-items:center; justify-content:center; z-index:300; padding:20px; }
                .cdp-modal { background:#fff; border-radius:14px; width:100%; max-width:620px; max-height:90vh; display:flex; flex-direction:column; box-shadow:0 20px 60px rgba(0,0,0,.2); }
                .cdp-modal-hd { display:flex; align-items:flex-start; justify-content:space-between; padding:22px 28px 18px; border-bottom:1px solid #f0ece8; flex-shrink:0; }
                .cdp-modal-dept  { font-size:0.78rem; color:#999; margin:0 0 4px; }
                .cdp-modal-title { font-size:1.05rem; font-weight:800; color:#1c1814; margin:0; }
                .cdp-modal-close { background:none; border:none; font-size:1.1rem; color:#aaa; cursor:pointer; padding:2px 4px; line-height:1; flex-shrink:0; transition:color .15s; }
                .cdp-modal-close:hover { color:#333; }
                .cdp-modal-body { padding:22px 28px; overflow-y:auto; flex:1; }
                .cdp-modal-ft { display:flex; gap:10px; justify-content:flex-end; padding-top:20px; margin-top:8px; border-top:1px solid #f0ece8; }

                /* 폼 공용 */
                .cdp-section-label { font-size:0.75rem; font-weight:700; letter-spacing:0.08em; text-transform:uppercase; color:#f16102; padding-bottom:8px; border-bottom:1.5px solid #fde8d8; margin:0 0 14px; }
                .cdp-row2  { display:grid; grid-template-columns:1fr 1fr; gap:14px; margin-bottom:14px; }
                .cdp-field { display:flex; flex-direction:column; gap:6px; margin-bottom:14px; }
                .cdp-field:last-child { margin-bottom:0; }
                .cdp-label { font-size:0.84rem; font-weight:600; color:#444; text-align:left; }
                .cdp-req   { color:#f16102; }
                .cdp-opt   { font-size:0.78rem; color:#bbb; font-weight:400; }
                .cdp-input, .cdp-textarea {
                    padding:10px 14px; border:1.5px solid #e0dbd5; border-radius:8px;
                    font-size:0.88rem; color:#333; outline:none; font-family:inherit;
                    transition:border-color .15s; box-sizing:border-box; background:#fff;
                }
                .cdp-input:focus, .cdp-textarea:focus { border-color:#f16102; }
                .cdp-textarea { resize:vertical; min-height:72px; }
                .cdp-input:disabled { background:#f2f0ee; color:#bbb; cursor:not-allowed; }
                .cdp-char-count { font-size:0.75rem; color:#bbb; text-align:right; }

                /* 생년월일 */
                .cdp-birth-row { display:grid; grid-template-columns:2fr 1.2fr 1.2fr; gap:8px; }
                .cdp-birth { position:relative; }
                .cdp-birth-btn { width:100%; display:flex; align-items:center; justify-content:space-between; border:1.5px solid #e0dbd5; border-radius:8px; padding:10px 14px; font-size:0.88rem; color:#333; background:#fff; cursor:pointer; font-family:inherit; text-align:left; transition:border-color .15s; }
                .cdp-birth-btn--open, .cdp-birth-btn:focus { border-color:#f16102; outline:none; }
                .cdp-birth-ph { color:#aaa; }
                .cdp-birth-arrow { font-size:0.8rem; color:#666; flex-shrink:0; }
                .cdp-birth-list { position:absolute; top:calc(100% + 4px); left:0; right:0; z-index:400; background:#fff; border:1.5px solid #f16102; border-radius:8px; max-height:180px; overflow-y:auto; margin:0; padding:4px 0; list-style:none; box-shadow:0 6px 20px rgba(0,0,0,.12); }
                .cdp-birth-item { padding:8px 14px; font-size:0.88rem; color:#333; cursor:pointer; transition:background .15s; }
                .cdp-birth-item:hover { background:#fff4ec; color:#f16102; }
                .cdp-birth-item--sel { background:#fff4ec; color:#f16102; font-weight:600; }

                /* 성별 */
                .cdp-radio-group { display:flex; gap:10px; }
                .cdp-radio { display:flex; align-items:center; justify-content:center; gap:6px; flex:1; padding:9px 0; border:1.5px solid #e0dbd5; border-radius:8px; font-size:0.88rem; font-weight:600; color:#666; cursor:pointer; transition:all .15s; }
                .cdp-radio input { display:none; }
                .cdp-radio--on { border-color:#f16102; color:#f16102; background:#fff8f4; }

                /* 이메일 */
                .cdp-email-row { display:flex; align-items:center; gap:8px; }
                .cdp-email-local { flex:1; min-width:0; }
                .cdp-at { font-size:1rem; font-weight:600; color:#555; flex-shrink:0; }
                .cdp-email-domain { flex:1; min-width:0; }
                .cdp-email-preview { font-size:0.8rem; color:#f16102; margin:4px 0 0; font-weight:500; }

                /* 커스텀 셀렉트 */
                .cdp-select { position:relative; width:100%; }
                .cdp-select-btn { width:100%; display:flex; align-items:center; justify-content:space-between; gap:8px; padding:10px 14px; border:1.5px solid #e0dbd5; border-radius:8px; background:#fff; font-size:0.88rem; color:#aaa; font-family:inherit; cursor:pointer; text-align:left; transition:border-color .15s; }
                .cdp-select-btn--val { color:#333; }
                .cdp-select-btn--open, .cdp-select-btn:focus { border-color:#f16102; outline:none; }
                .cdp-select-arrow { flex-shrink:0; color:#f16102; transition:transform .2s; }
                .cdp-select-arrow.open { transform:rotate(180deg); }
                .cdp-select-list { position:absolute; top:calc(100% + 4px); left:0; right:0; background:#fff; border:1.5px solid #f16102; border-radius:10px; box-shadow:0 8px 24px rgba(0,0,0,.1); padding:6px; margin:0; list-style:none; z-index:400; }
                .cdp-select-item { display:flex; align-items:center; gap:8px; padding:9px 14px; font-size:0.88rem; color:#444; border-radius:7px; cursor:pointer; transition:background .15s; }
                .cdp-select-item:hover { background:#fff8f4; color:#f16102; }
                .cdp-select-item--sel { background:#fff3eb; color:#f16102; font-weight:600; }

                /* 주소 */
                .cdp-addr-row { display:flex; gap:8px; }
                .cdp-addr-input { flex:1; background:#faf7f4; cursor:default; }
                .cdp-addr-btn { white-space:nowrap; padding:10px 16px; background:#f16102; color:#fff; border:none; border-radius:8px; font-size:0.84rem; font-weight:600; cursor:pointer; transition:background .2s; flex-shrink:0; }
                .cdp-addr-btn:hover { background:#d95502; }

                /* 경력사항 */
                .cdp-career-header { display:flex; align-items:center; justify-content:space-between; margin-bottom:10px; }
                .cdp-career-add { display:inline-flex; align-items:center; gap:5px; padding:6px 12px; background:#f16102; color:#fff; border:none; border-radius:7px; font-size:0.8rem; font-weight:600; cursor:pointer; transition:background .2s; }
                .cdp-career-add:hover { background:#d95502; }
                .cdp-career-empty { padding:14px; background:#faf7f4; border:1.5px dashed #e0dbd5; border-radius:10px; text-align:center; font-size:0.83rem; color:#aaa; margin-bottom:14px; }
                .cdp-career-item { border:1.5px solid #e0dbd5; border-radius:10px; overflow:hidden; margin-bottom:12px; }
                .cdp-career-item-hd { display:flex; align-items:center; justify-content:space-between; padding:9px 14px; background:#faf7f4; border-bottom:1.5px solid #e0dbd5; }
                .cdp-career-num { font-size:0.8rem; font-weight:700; color:#f16102; }
                .cdp-career-del { background:none; border:1.5px solid #e0dbd5; border-radius:6px; padding:3px 10px; font-size:0.78rem; font-weight:600; color:#888; cursor:pointer; transition:all .15s; }
                .cdp-career-del:hover { border-color:#f16102; color:#f16102; background:#fff4ec; }
                .cdp-career-body { padding:14px; display:flex; flex-direction:column; gap:12px; }
                .cdp-period { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
                .cdp-period .cdp-input { flex:1; min-width:100px; }
                .cdp-period-sep { font-size:0.9rem; color:#888; flex-shrink:0; }
                .cdp-current-check { display:inline-flex; align-items:center; gap:5px; font-size:0.82rem; font-weight:600; color:#555; cursor:pointer; white-space:nowrap; flex-shrink:0; }
                .cdp-current-check input[type="checkbox"] { accent-color:#f16102; width:14px; height:14px; cursor:pointer; }

                /* e클린서비스 파일 업로드 */
                .cdp-upload { border:2px dashed #e0dbd5; border-radius:10px; background:#faf7f4; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:6px; padding:22px; cursor:pointer; font-size:0.87rem; color:#888; text-align:center; transition:border-color .2s; margin-bottom:16px; }
                .cdp-upload:hover { border-color:#f16102; }
                .cdp-upload-icon { font-size:1.3rem; color:#f16102; }
                .cdp-upload-hint { font-size:0.75rem; color:#bbb; }
                .cdp-upload-name { font-size:0.88rem; color:#f16102; font-weight:600; }

                /* 개인정보 동의 */
                .cdp-privacy { display:flex; align-items:flex-start; gap:8px; font-size:0.84rem; color:#555; cursor:pointer; margin-bottom:14px; }
                .cdp-privacy input { accent-color:#f16102; margin-top:2px; flex-shrink:0; }
                .cdp-terms-link { background:none; border:none; color:#f16102; font-size:0.84rem; font-weight:600; cursor:pointer; padding:0; text-decoration:underline; }

                /* 에러 */
                .cdp-error { font-size:0.82rem; color:#e53e3e; background:#fff5f5; border:1px solid #fed7d7; border-radius:6px; padding:10px 14px; margin:0 0 14px; }

                /* 버튼 */
                .cdp-btn-cancel { padding:11px 22px; background:#fff; border:1.5px solid #ddd; border-radius:8px; font-size:0.88rem; font-weight:600; color:#555; cursor:pointer; transition:border-color .15s; }
                .cdp-btn-cancel:hover { border-color:#aaa; color:#333; }
                .cdp-btn-submit { padding:11px 32px; background:#1c1814; color:#fff; border:none; border-radius:8px; font-size:0.9rem; font-weight:700; cursor:pointer; transition:background .15s; }
                .cdp-btn-submit:hover:not(:disabled) { background:#f16102; }
                .cdp-btn-submit:disabled { opacity:.55; cursor:not-allowed; }

                /* 약관 모달 */
                .cdp-terms-backdrop { position:fixed; inset:0; background:rgba(0,0,0,.5); display:flex; align-items:center; justify-content:center; z-index:500; padding:20px; }
                .cdp-terms-modal { background:#fff; border-radius:14px; width:100%; max-width:540px; max-height:80vh; display:flex; flex-direction:column; }
                .cdp-terms-hd { display:flex; justify-content:space-between; align-items:center; padding:18px 24px; border-bottom:1px solid #f0ebe6; }
                .cdp-terms-hd h3 { margin:0; font-size:1rem; font-weight:700; }
                .cdp-terms-body { flex:1; overflow-y:auto; padding:18px 24px; font-size:0.84rem; color:#555; line-height:1.8; text-align:left; }
                .cdp-terms-body p { margin:0 0 4px; }
                .cdp-terms-ft { padding:14px 24px; border-top:1px solid #f0ebe6; display:flex; justify-content:flex-end; }
                .cdp-terms-ft .cdp-btn-submit { padding:10px 28px; }

                /* ── 상태 화면 ── */
                .crd2-state { display:flex; flex-direction:column; align-items:center; justify-content:center; text-align:center; padding:120px 20px 80px; min-height:60vh; }
                .crd2-state-title { font-size:1.25rem; font-weight:700; color:#1c1814; margin:0 0 10px; }
                .crd2-state-sub   { font-size:0.9rem; color:#888; margin:0; line-height:1.6; }
                .crd2-btn-primary { margin-top:24px; padding:12px 32px; background:#1c1814; color:#fff; border:none; border-radius:6px; font-size:0.9rem; font-weight:700; cursor:pointer; transition:background .15s; }
                .crd2-btn-primary:hover { background:#f16102; }
                .crd2-success-icon { margin-bottom:20px; }
                .crd2-circle { stroke-dasharray:157; stroke-dashoffset:157; animation:crd2Circle .6s ease forwards; }
                .crd2-check  { stroke-dasharray:40;  stroke-dashoffset:40;  animation:crd2Check .4s ease .5s forwards; }
                @keyframes crd2Circle { to { stroke-dashoffset:0; } }
                @keyframes crd2Check  { to { stroke-dashoffset:0; } }
                .crd2-spinner { width:32px; height:32px; border:3px solid #e9ecef; border-top-color:#f16102; border-radius:50%; animation:crd2Spin .9s linear infinite; margin:0 auto 14px; }
                @keyframes crd2Spin { to { transform:rotate(360deg); } }

                /* ── 반응형 ── */
                @media (max-width: 700px) {
                    .crd2-wrap { padding:24px 24px 40px; }
                    .crd2-title { font-size:1.35rem; }
                    .crd2-dday-banner { flex-direction:column; align-items:flex-start; }
                    .crd2-job-card { padding:20px 18px; }
                    .cdp-row2 { grid-template-columns:1fr; }
                    .cdp-modal { max-height:95vh; }
                    .cdp-modal-hd, .cdp-modal-body { padding-left:18px; padding-right:18px; }
                    .cdp-birth-row { grid-template-columns:1fr 1fr 1fr; gap:6px; }
                    .cdp-email-row { flex-direction:column; align-items:stretch; }
                    .cdp-period { flex-direction:column; align-items:stretch; }
                    .cdp-period .cdp-input { min-width:unset; }
                    .cdp-period-sep { display:none; }
                }
            `}</style>
        </>
    );
}
